import React, { createContext, useState, useEffect } from 'react';
import { risapi } from '../api/risapi';
import { useNavigate } from 'react-router-dom';


const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  const navigate = useNavigate();
  
  

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    console.log("storedToken",storedToken);
    
    if (storedToken) {
      setToken(storedToken);
    }
   
   
  },);

  useEffect(() => {
    const fetchUserData = async () => {
     
      if (token) {
        console.log("calling here");
        
        try {
          const response = await risapi.get('/api/user', { // Replace with your API endpoint
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log("data response",response.data);
          
          setUser(response.data);
        } catch (error) {
          console.error('Error fetching user data:', error);
          navigate('/login');
          // Handle error (e.g., token expired, invalid token)
          // if (error.response && error.response.status === 401) {
          //   // Token is invalid, log out the user
          //   logout();
          // }
        }
      }
     else {
      // No token, set user to null
      setUser(null);
     
    }
      
    };

    fetchUserData();
  }, [token]);

  const login = (token) => {
    console.log("tokenval",token);
    
    setToken(token);
    localStorage.setItem('token', token);
  };

  

  return (
    <AuthContext.Provider value={{ user, token, login,setToken,setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };